import { ReactNode } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { IAskLoginModalProps } from './ask-login-modal.models';
import { useStyles } from './ask-login-modal.styles';
import { Modal, ResponsiveWidth } from '../modal';
import { Button } from '../button-new';
import { v2026PP05841 } from '../../../constants/veeva';

export const AskLoginModal = ({
  title, onNavigateToRegistration, onNavigateToLogin, ...props
}: IAskLoginModalProps): JSX.Element => {
  const intl = useIntl();
  const classes = useStyles();

  return (
    <Modal
      {...props}
      data-testid="ask-login-modal"
      responsiveWidth={ResponsiveWidth.lg}
      propsPaperStyles={classes.propsPaperStyles}
      propsContentStyles={classes.propsContentStyles}
      veevaNumber={v2026PP05841}
      content={(
        <>
          <h2 className={classes.title}>
            {intl.formatMessage(
              { id: title || 'askLogin.popup.title' },
              { sup: (chunks: ReactNode) => <sup>{chunks}</sup> },
            )}
          </h2>
          <p className={classes.description}>
            <FormattedMessage id="askLogin.popup.text" />
          </p>
          <div className={classes.actions}>
            <Button
              style="dark"
              onClick={onNavigateToRegistration}
              testId="ask-login-register" //Don't remove this test id, it is used by YaMetrica
            >
              <FormattedMessage id="askLogin.popup.registerButton.label" />
            </Button>
            <Button
              style="outlined"
              rootClasses={classes.login}
              onClick={onNavigateToLogin}
              testId="ask-login-login" //Don't remove this test id, it is used by YaMetrica
            >
              <FormattedMessage id="askLogin.popup.loginButton.label" />
            </Button>
          </div>
        </>
      )}
    />
  );
};
